export const acceptedFileTypes = [
  'image/*',
  'application/pdf',
  'application/rtf',
  'text/calendar',
  'text/vcard',
  'video/*'
]
export const maxFileSize = '500KB'

export const viewableImgExtensions = ['gif', 'jpg', 'jpeg', 'pjpeg', 'png', 'svg', 'webp']
export const viewableFileExtensions = ['pdf', 'rtf', 'txt', 'cal', 'vcf', 'vcard', '3gp']

export const viewableVideoExtensions = [
  'avi',
  'mp4',
  'm4v',
  'mpg',
  'mpeg',
  'm1v',
  'mpv',
  'ogv',
  'ogx',
  'ogg',
  'spx',
  'ogm',
  'mov',
  'qt',
  'webm',
  'wmv'
]
